/**
 * Performance Timing Utility
 * Simple timing markers for cold start diagnostics
 */

const timings: Record<string, number> = {};
const DEBUG_TIMINGS = true; // Can be disabled in production

/**
 * Mark the start of a timing
 */
export function markStart(label: string): void {
  if (!DEBUG_TIMINGS) return;
  timings[label] = performance.now();
  console.time(`[Timing] ${label}`);
}

/**
 * Mark the end of a timing and log duration
 */
export function markEnd(label: string): number {
  if (!DEBUG_TIMINGS) return 0;
  console.timeEnd(`[Timing] ${label}`);
  const startTime = timings[label];
  if (startTime) {
    const duration = performance.now() - startTime;
    delete timings[label];
    return duration;
  }
  return 0;
}

/**
 * Log a performance mark (single point in time)
 */
export function mark(label: string): void {
  if (!DEBUG_TIMINGS) return;
  console.log(`[Timing] ${label}: ${performance.now().toFixed(2)}ms from page load`);
}

/**
 * Get all current timings for debugging
 */
export function getAllTimings(): Record<string, number> {
  return { ...timings };
}
